// „Projekte" (frontend/src/pages/Projects.tsx) — deutsche QUELLE.
//
// Achtung: der system-seedete Projektname „My SOPs" ist ein Lookup-Key in der
// Datenbank (sync_users.py) und wird NUR im Frontend gemappt
// (ui/labels.ts::projectDisplayName). Er darf nicht in der Datenbank umbenannt
// werden — auch nicht „für die englische Fassung".
export const projects = {
  // Kanban-Spalten. Eigene Map statt ui/labels.ts, weil hier drei feste
  // Spalten stehen und nicht ein beliebiger Status-String übersetzt wird.
  spalten: {
    open: "Offen",
    in_progress: "In Arbeit",
    done: "Erledigt",
  },

  // Leerzustand / Anlegen
  projektWaehlen: "Wähle ein Projekt aus der Sidebar links.",
  deineProjekte: "Deine Projekte",
  eigeneOderNeu: (n: number) => `${n} eigene · oder lege ein neues an.`,
  neuesProjektPlatzhalter: "Neues Projekt …",
  neuesProjektAnlegen: "Neues Projekt anlegen",
  projektAngelegt: "Projekt angelegt",

  // Kopfzeile
  inSalesforceOeffnen: "In Salesforce öffnen",
  aufgabe: "Aufgabe",
  kontext: "Kontext",
  kontextTitel: "Instruktionen & Wissen anzeigen",
  projektAktionen: "Projekt-Aktionen",
  projektLoeschen: "Projekt löschen",

  // Workstreams
  alle: "Alle",
  ohneWorkstream: "Ohne Workstream",
  workstream: "Workstream",
  workstreamAktionen: (name: string) => `Aktionen für Workstream ${name}`,
  workstreamLoeschenFrage: (name: string) => `Workstream „${name}" löschen?`,
  workstreamLoeschenHinweis:
    "Nur leere Workstreams lassen sich löschen. Solange noch Tasks, Handoffs " +
    "oder ein aktiver Session-Lock daranhängen, lehnt der Server ab und nennt, " +
    "was blockiert.",
  workstreamLoeschenFehlgeschlagen: "Workstream löschen fehlgeschlagen",

  // Kanban
  leer: "(leer)",
  aufgabeHinzufuegen: "+ Aufgabe",
  salesforceReadOnly: "Salesforce (read-only)",
  ueberfaellig: "überfällig",
  brauchtEntscheidung: "Braucht Entscheidung",
  wartetAufAntwort: "Wartet auf Antwort",
  oeffnen: "öffnen",
  statusNichtGeaendert: "Konnte Status nicht ändern",

  // Projekt löschen
  projektLoeschenFrage: (name: string) => `Projekt „${name}" löschen?`,
  loeschenLaeuft: "Löschen …",
  endgueltigLoeschen: "Endgültig löschen",
  loeschHinweisDauerhaft:
    "Das Projekt wird dauerhaft entfernt. Diese Aktion kann nicht rückgängig gemacht werden.",
  loeschHinweisAlle: "Alle",
  phasenWorkstreams: "Phasen/Workstreams",
  loeschHinweisRest:
    "dieses Projekts werden mitgelöscht. Aufgaben und Notizen bleiben erhalten, verlieren aber ihre Projekt-Zuordnung.",
  projektGeloescht: "Projekt gelöscht",
  loeschenFehlgeschlagenPunkt: "Löschen fehlgeschlagen.",
  loeschenFehlgeschlagenMit: (fehler: string) => `Löschen fehlgeschlagen: ${fehler}`,

  // Artefakte / Präsentationen
  neuesArtefakt: "Neues Artefakt",
  praesentation: "Präsentation",
  praesentationBeschreibung:
    "Mehrseitiges PPTX mit Agent-Pipeline (Outline → Slides → Render)",
  blog: "Blog",
  blogArtikel: "Blog-Artikel",
  blogArtikelBeschreibung:
    "Bald verfügbar — TOC → Sections, basierend auf Knowledge + externen Quellen",
  video: "Video",
  heygenVideo: "Heygen-Video",
  heygenVideoBeschreibung:
    "Bald verfügbar — aus Blog-Artikel werden Scenes mit Avataren abgeleitet",
  keineArtefakte: "Noch keine Artefakte. Klick „Neues Artefakt\" oben.",
  keineTrefferFilter: "Keine Treffer für diesen Filter.",
  blogAgentFehlt: "Blog-Artikel-Agent ist noch nicht gebaut (Phase 4 — geplant nach Mo).",
  videoAgentFehlt:
    "Heygen-Video-Agent ist noch nicht gebaut (Phase 5 — braucht Marketing-API-Erweiterung).",
  praesentationLoeschenFrage: (titel: string) => `Präsentation „${titel}" löschen?`,
  vorschauOeffnen: "Preview oeffnen",
  slides: (n: number) => `${n} Slides`,
  preview: "Preview",
  pptxHerunterladen: "PPTX direkt downloaden",
};

export type ProjectsKatalog = typeof projects;
